import { useContext } from 'react';
import { PolicyNoticeContext, type PolicyNoticeContextValue } from '@/contexts/policyNoticeContextObj';

/** 改定の告知（contexts/PolicyNoticeContext.tsx）を開く */
export function usePolicyNotice(): PolicyNoticeContextValue {
  return useContext(PolicyNoticeContext);
}
